import defaultText from '../../config';

const languageSelectorReducer = (language = defaultText['en'], action) => {
    switch(action.type) {
        case 'SET_LANGUAGE':
            return action.payload;
        default:
            //debugger;
            return language;
    }
};

export default languageSelectorReducer;